import {useQuery} from '@apollo/react-hooks';

import type {
    GetMaterializedEmailSequence as GetMaterializedEmailSequenceQuery,
    GetMaterializedEmailSequenceVariables as GetMaterializedEmailSequenceQueryVariables,
} from 'nutshell-graphql-types';

import GET_MATERIALIZED_EMAIL_SEQUENCE from '../graphql/queries/get-materialized-email-sequence.graphql';

import {addBlotsToEmailSequence} from './helpers';
import {CREATE_FROM_SCRATCH_ID} from './types';

export const useGetMaterializedSequenceTemplate = (
    emailSequenceTemplateId?: string | null,
    primaryRecipientId?: string | null
) => {
    const {data, loading} = useQuery<
        GetMaterializedEmailSequenceQuery,
        GetMaterializedEmailSequenceQueryVariables
    >(GET_MATERIALIZED_EMAIL_SEQUENCE, {
        skip:
            !primaryRecipientId ||
            !emailSequenceTemplateId ||
            emailSequenceTemplateId === CREATE_FROM_SCRATCH_ID,
        variables: {
            // @ts-expect-error
            emailSequenceTemplateId,
            entityId: primaryRecipientId || '', // fine because of the skip above
        },
        fetchPolicy: 'cache-and-network',
    });

    const materializedEmailSequenceTemplate = data ? data.materializedEmailSequenceTemplate : null;
    const materializedSequenceTemplate = addBlotsToEmailSequence(materializedEmailSequenceTemplate);

    return {
        materializedSequenceTemplate,
        isMaterializing: loading,
    };
};
